import { Truck, Layers, ShieldCheck, Headphones } from "lucide-react";
import Reveal from "./Reveal";

const BENEFITS = [
  {
    icon: Truck,
    code: "Delivery",
    title: "Diantar ke Lokasi",
    desc: "Pesanan sewa diantar langsung ke lokasi proyek Anda.",
    testid: "benefit-delivery",
  },
  {
    icon: Layers,
    code: "Inventory",
    title: "Steger Lengkap",
    desc: "Berbagai kebutuhan steger tersedia untuk mendukung pekerjaan konstruksi.",
    testid: "benefit-complete",
  },
  {
    icon: ShieldCheck,
    code: "Quality",
    title: "Kualitas Terjaga",
    desc: "Steger dipersiapkan untuk kebutuhan proyek dan penggunaan di lapangan.",
    testid: "benefit-quality",
  },
  {
    icon: Headphones,
    code: "Support",
    title: "Siap Membantu",
    desc: "Konsultasikan kebutuhan steger Anda bersama tim kami.",
    testid: "benefit-support",
  },
];

const WhyUs = () => (
  <section
    id="why-us"
    data-testid="why-us-section"
    className="border-b border-[#E5E2DA] bg-[#F7F5F0] py-20 lg:py-28"
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <p className="font-tech mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#525866]">
            <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
            Why Us
            <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
          </p>
          <h2 className="font-display text-3xl font-semibold uppercase tracking-wide text-[#141619] sm:text-4xl lg:text-5xl">
            KENAPA MITRA
            <br />
            BANGUN UTAMA<span className="text-[#DF9F00]">?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <p className="max-w-md text-base leading-relaxed text-[#525866]">
            Kami menyediakan kebutuhan steger untuk membantu pekerjaan konstruksi
            berjalan lebih praktis dan siap.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#E5E2DA] bg-[#E5E2DA] sm:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.1} className="h-full">
            <div
              data-testid={b.testid}
              className="group flex h-full flex-col bg-[#F7F5F0] p-8 transition-colors duration-500 hover:bg-[#141619]"
            >
              <div className="flex items-center justify-between">
                <b.icon
                  className="h-7 w-7 text-[#DF9F00] transition-transform duration-500 group-hover:-translate-y-1"
                  strokeWidth={1.5}
                />
                <span className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#525866] group-hover:text-white/40">
                  {b.code}
                </span>
              </div>
              <h3 className="font-display mt-10 text-xl font-semibold tracking-normal text-[#141619] transition-colors duration-500 group-hover:text-white">
                {b.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#525866] transition-colors duration-500 group-hover:text-white/60">
                {b.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
